import Marquee from 'react-fast-marquee';
import { Zap } from 'lucide-react';
import { KRAFT } from '@/constants/testIds';

const ITEMS = [
  'Prawo Budowlane',
  'Uprawnienia SEP',
  'Normy BHP',
  'Odbiory techniczne',
  'Protokoły pomiarowe',
  'PN-IEC 60364',
];

export default function EditorialMarquee() {
  return (
    <section
      id="marquee"
      data-testid={KRAFT.marqueeRoot}
      className="relative bg-ink-950 border-y border-white/10 py-8 md:py-10 overflow-hidden"
    >
      <Marquee gradient={false} speed={35} pauseOnHover>
        {ITEMS.concat(ITEMS).map((label, i) => (
          <div key={i} className="flex items-center gap-6 px-8">
            <Zap className="w-5 h-5 text-volt shrink-0" strokeWidth={2} />
            <span className="font-display uppercase tracking-tight text-white text-4xl md:text-5xl lg:text-6xl whitespace-nowrap">
              {label}
            </span>
            <span className="font-display uppercase tracking-tight text-white/10 text-4xl md:text-5xl lg:text-6xl whitespace-nowrap">
              ·
            </span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
